import { configNoHeaders, configNoHeadersV2 } from '@api/constructor-api'
import store from '../store';

const branchInfoHandler = async (branchUUID) => {
  return await configNoHeaders(async (API) => {
    if(branchUUID != null && branchUUID != 'null')
      return await API.get(`branches/${branchUUID}`);
    throw 'Not Empty Data'
  })
}

const branchListHandler = async () => {
  return await configNoHeadersV2(async (API) => {
    const restaurantUUID = store.getters['restaurant/restaurantUUID']
    if(restaurantUUID != null && restaurantUUID != 'null')
      return await API.get(`/package/branches-list`, { params: { restaurantUUID } });
    throw 'Not Empty Data'
  })
}

export {
  branchInfoHandler,
  branchListHandler,
}
